import React, {useEffect, useState} from "react";
import {Button, ButtonGroup, Chip, Divider, Input, Select, SelectItem} from "@nextui-org/react";
import {FaEnvelope, FaPlusCircle, FaPhoneAlt, FaUserAlt, FaLock} from 'react-icons/fa';
import {useLocation, useNavigate} from "react-router-dom";
import {SaveStock} from "../API";
import Cookies from "universal-cookie";
import {StockStatus} from "./Globals";

export default function StockEdit() {
    const [stock, setStock] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const {data} = location.state || {};
    const navigate = useNavigate();

    useEffect(
        () => {
            Starting();
        }, []
    )

    async function Starting() {
        setStock(data);
    }

    async function Save(e){
        e.preventDefault();
        setIsLoading(true);

        //const res = await SaveStock(stock);
        navigate("/dashboard/stock-list");
        setIsLoading(false);
    }

    return (
        <>
            <h1 className="pb-5 text-2xl"><b
                className='text-warning'>Producto: {stock.name}</b>
            </h1>
            <form className="flex flex-col w-full flex-wrap gap-4" onSubmit={Save}>

                <h1 className="text-warning text-xl">Datos actuales</h1>

                {
                    stock.status ? (
                        <Chip color={StockStatus[stock.status][0]} className="text-md">Estado
                            actual: {StockStatus[stock.status][1]}</Chip>
                    ):null
                }
                <Input
                    type="text"
                    label="IdStock"
                    labelPlacement="outside"
                    value={stock.idstock}
                    isReadOnly
                />
                <Input
                    type="text"
                    label="Codigo de celda"
                    labelPlacement="outside"
                    value={stock.code}
                    isReadOnly
                />
                <Input
                    type="text"
                    label="Codigo de stock"
                    labelPlacement="outside"
                    value={stock.code_stock}
                    isReadOnly
                />
                <Input
                    type="text"
                    label="Repositor encargado"
                    labelPlacement="outside"
                    value={stock.username}
                    isReadOnly
                />
                <Divider className="mt-5"/>
                <h1 className="text-warning text-xl">Cambiar de estado</h1>
                <Select
                    labelPlacement="outside"
                    label="Estado"
                    name="parent">
                    <SelectItem>Con repositor</SelectItem>
                    <SelectItem>Dañado</SelectItem>
                </Select>

                <div className="container text-center">
                    <Button color="danger" type="submit"
                            size="lg" isLoading={isLoading}>Actualizar</Button>

                </div>

            </form>
        </>
    );
}
